import React from 'react';
import TopologyBox, { TopologyBoxProps } from './topologyBox';
import { Box } from '@mui/material';
import './dotsAnimation.css';
import TopologyFlow, { TopologyFlowProps } from './topologyFlow';
import useIsMobile from '../../../hooks/useIsMobile';

interface TopologyColumnProps {
  topBox?: TopologyBoxProps;
  centerBox?: TopologyBoxProps;
  bottomBox?: TopologyBoxProps;
  topConnection?: TopologyFlowProps;
  centerConnection?: TopologyFlowProps;
  bottomConnection?: TopologyFlowProps;
  isLast: boolean;
  isFirst: boolean;
}

function TopologyColumn(props: TopologyColumnProps) {
  const isMobile = window.innerWidth <= 1490;
  // Phones (<md): keep the horizontal diagram but pack it tight (small gaps,
  // no between-column animation) so the WHOLE picture fits the screen width.
  const isPhone = useIsMobile();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft:
          props.isFirst ? '0px' : isPhone ? '8px' : isMobile ? '52px' : '68px',
        flexShrink: { xs: 0, md: 1 }
      }}
    >
      {/* On phones, skip empty placeholder boxes so tight/wrapped columns don't
          carry ~150px of invisible height. Desktop keeps them for alignment. */}
      {(props.topBox || !isPhone) && (
        <TopologyBox {...props.topBox}></TopologyBox>
      )}

      {props.topBox && props.centerBox && (
        <TopologyFlow {...props.topConnection} />
      )}
      {(props.centerBox || !isPhone) && (
        <TopologyBox {...props.centerBox}></TopologyBox>
      )}
      {/* Hide the horizontal (between-column) connector animation on phones —
          no room once boxes are packed to fit. Vertical in-column arrows stay.
          Desktop is unchanged. */}
      {!props.isLast && !isPhone && (
        <TopologyFlow {...props.centerConnection} />
      )}

      {props.centerBox && props.bottomBox && (
        <TopologyFlow {...props.bottomConnection} />
      )}
      {(props.bottomBox || !isPhone) && (
        <TopologyBox {...props.bottomBox}></TopologyBox>
      )}
    </Box>
  );
}

export default TopologyColumn;
